import React, { useState } from "react";
import BushbuckBg from "../../assets/images/bushbuck-bg.png";
import { Link, navigate } from "gatsby";
import { useDispatch, useSelector } from "react-redux";
import { CreateNewAccount, Login } from "../../lib/dynamicQueries/account";
import { userLoggedIn, updateShopper } from "../../slices/auth";
import { getError } from "../../utils/errorCodes";
import InputField from "../account/InputField";
import PasswordField from "../common/PasswordField";
import { getCurrentPath } from "../../utils/getCurrentPath";
import { parsePhoneNumber } from "react-phone-number-input";
import {UpdateBuyerInCart} from "../../lib/dynamicQueries/cart";

const LOCALE = process.env.GATSBY_LOCALE_COUNTRY;
const IS_PARTNERS = process.env.GATSBY_CLUB_ACTIVE === "club_pt";

const Form = () => {
  const dispatch = useDispatch();
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [email, setEmail] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [mobileno, setMobileNo] = useState("");
  const [parsedMobileNo, setParsedMobileNo] = useState("");
  const [mobileNumberIsValid, setMobileNumberIsValid] = useState(false);
  const [terms, setTerms] = useState(false);
  const [marketing, setMarketing] = useState(false);
  const [error, setError] = useState("");
  const { cartId } = useSelector(
      (state) => state.cart
  );

  function validatePhoneNumber(phoneNumber) {
    setMobileNumberIsValid(false);
    setMobileNo(phoneNumber);
    setParsedMobileNo("");
    const parsedPhoneNumber = parsePhoneNumber(phoneNumber, LOCALE);
    if (parsedPhoneNumber) {
      setParsedMobileNo(parsedPhoneNumber.number);
      setMobileNumberIsValid(true);
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (email.toLowerCase() !== confirmEmail.toLowerCase()) {
      setError("Email and Confirm Email should be the same");
    } else if (password !== confirmPassword) {
      setError("Password and Confirm Password should be the same");
    } else if (
      email.toLowerCase() === confirmEmail.toLowerCase() &&
      password === confirmPassword
    ) {
      const userResponse = await CreateNewAccount({
        fname,
        lname,
        email,
        password,
        mobileno: parsedMobileNo,
        marketing,
      });
      if (userResponse?.customer) {
        const response = await Login({ email, password });
        if (response.customerAccessToken) {
          setError("");
          dispatch(
            userLoggedIn({
              ...userResponse.customer,
              ...response.customerAccessToken,
            })
          );
          dispatch(updateShopper(email));
          if (cartId) {
            await UpdateBuyerInCart(cartId, {
              accessToken: response.customerAccessToken.accessToken,
              email
            });
          }
          if (IS_PARTNERS) {
            navigate("/account");
          } else {
            navigate("/pages/bushbuck-club");
          }
        } else {
          const err = getError(
            response.customerUserErrors[0].code,
            response.customerUserErrors[0].message
          );
          setError(err);
        }
      } else {
        const err = getError(
          userResponse?.customerUserErrors[0].code,
          userResponse?.customerUserErrors[0].message
        );
        setError(err);
      }
    }
  }

  return (
    <div className="bg-[#f2f2f2] relative pt-[92px] pb-10">
      <div
        className="absolute contents-[''] top-0 right-0 w-full h-full bg-no-repeat bg-cover z-0 opacity-20"
        style={{ backgroundImage: `url(${BushbuckBg})` }}
      />

      <div className="max-w-[1054px] w-full mx-auto relative z-[2] px-5 md:px-10">
        <form
          onSubmit={handleSubmit}
          className="w-full grid grid-cols-1 md:grid-cols-2 md:gap-x-10 lg:gap-x-20 gap-y-4 md:gap-y-8 text-black font-normal justify-between md:border
        md:border-solid md:border-black/20 py-5 sm:py-10 px-5 md:px-10 xl:px-20 bg-white rounded-2xl"
        >
          <div className="md:col-span-2 max-w-2xl w-full mx-auto text-center text-black mb-5">
            <h2 className="text-3xl md:text-[40px] font-bold leading-[45px] md:leading-[60px] mb-[10px]">
              {IS_PARTNERS && "Create Account"}
              {!IS_PARTNERS && "Join the Bushbuck Club"}
            </h2>
          </div>
          <div className="max-w-[602px] w-full">
            <InputField
              title="Email *"
              type="email"
              label="Announcement_CustomerEmail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="max-w-[602px] ml-auto w-full">
            <InputField
              title="Confirm Email *"
              type="email"
              label="Announcement_CustomerConfirmEmail"
              value={confirmEmail}
              onChange={(e) => setConfirmEmail(e.target.value)}
              required
            />
          </div>
          <div className="max-w-[602px] w-full">
            <PasswordField
              title="Password  *"
              label="Announcement_CustomerPassword"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className="max-w-[602px] w-full ml-auto">
            <PasswordField
              title="Confirm Password *"
              type="password"
              label="CustomerConfirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          <div className="max-w-[602px] w-full">
            <InputField
              title="First name *"
              type="text"
              label="CustomerFirstName"
              value={fname}
              onChange={(e) => setFname(e.target.value)}
              required
            />
          </div>
          <div className="max-w-[602px] w-full ml-auto">
            <InputField
              title="Last name *"
              type="text"
              label="CustomerLastName"
              value={lname}
              onChange={(e) => setLname(e.target.value)}
              required
            />
          </div>
          <div className="max-w-[602px] w-full">
            <InputField
              title="Mobile Number"
              type="tel"
              label="MobileNumber"
              value={mobileno}
              onChange={(e) => validatePhoneNumber(e.target.value)}
            />
            {!mobileNumberIsValid && mobileno.length > 0 && (
              <div className="flex items-center mr-4">
                <p className="text-base font-medium text-red-600">
                  * Please enter a valid mobile phone number
                </p>
              </div>
            )}
          </div>
          <div className="md:col-span-2 space-y-6 mt-5">
            <div className="flex items-center mr-4">
              <input
                type="checkbox"
                id="announcement_terms"
                className="w-4 h-4 text-[8px] accent-secondary-500"
                checked={terms}
                onChange={() => setTerms(!terms)}
                required
              />
              <label
                htmlFor="announcement_terms"
                className="ml-2 text-sm font-normal text-gray-900"
              >
                I agree to the{" "}
                <Link
                  to="/pages/terms-conditions"
                  className="underline underline-offset-2"
                >
                  Terms & Conditions
                </Link>{" "}
                and{" "}
                <Link
                  to="/pages/privacy-policy"
                  className="underline underline-offset-2"
                >
                  Privacy Policy
                </Link>{" "}
                {IS_PARTNERS && "for creating an account."}
                {!IS_PARTNERS && "for creating a club account."}
              </label>
            </div>
            <div className="flex items-center mr-4">
              <input
                type="checkbox"
                id="marketing3"
                className="w-4 h-4 text-[8px] accent-secondary-500"
                checked={marketing}
                onChange={() => setMarketing(!marketing)}
              />
              <label
                htmlFor="marketing3"
                className="ml-2 text-sm font-normal text-gray-900"
              >
                Sign me up to receive exclusive Bushbuck Club Deals & Reward
                Points
              </label>
            </div>
            {error && (
              <div className="flex items-center mr-4">
                <p className="text-base font-medium text-red-600">* {error}</p>
              </div>
            )}
          </div>
          {/* {error && (
          <p className="leading-7 font-medium mt-5 text-secondary-500">
            {error}
          </p>
        )} */}
          <div className="md:col-span-2 text-center mt-10">
            <button
              className="max-w-[490px] w-full px-[35px] h-[55px] text-white text-center bg-[#231F20] rounded-full cursor-pointer
                flex items-center justify-center mx-auto hover:scale-105 transition-transform duration-200 ease-in tracking-wide"
              type="submit"
            >
              <span>Join for Free</span>
            </button>
          </div>
        </form>
        <div className="block text-primary-500 text-center font-normal mt-11">
          <p className="text-base text-center text-primary-500 tracking-wide inline-block">
            Already a Bushbuck {!IS_PARTNERS && "Club "}Member?{" "}
            <Link
              to="/account/login"
              state={{ redirectTo: getCurrentPath() }}
              className="inline-block tracking-normal text-sm font-bold uppercase underline"
            >
              Login here
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Form;
